// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m4g6","label":"styles_label__3GzOc"};